import React, { useEffect, useState } from "react";
import {
	Col,
	Container,
	Row,
	Breadcrumb,
	BreadcrumbItem,
	Modal,
} from "reactstrap";
import "assets/scss/website/app.scss";
import { MetaTags } from "react-meta-tags";
import "react-rangeslider/lib/index.css";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import HomeService from "services/Website/HomeService";
import { SuccessOk } from "configs/statusCode";
import { useSelector, useDispatch } from "react-redux";
import SideFilters from "components/Website/SideFilters";
import CompoundCard from "components/Website/Cards/CompoundCard";
import { Link } from "react-router-dom";
import { resetFilters } from "store/filter/actions";
import Navbar from "components/Website/Layouts/Navbar";
import Footer from "components/Website/Layouts/Footer";
import { appendFilters } from "store/filter/actions";
import Paginator from "./Paginator";
import Skeleton from "components/Website/Skeleton";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import CompoundSearchService from "services/Website/CompoundSearchService";
import PaginatorNewProjects from "./PaginatorNewProject";

const CompoundsPage = (props) => {
	const { t } = useTranslation();
	const filterData = useSelector((state) => state.filter);
	const [compoundList, setCompoundList] = useState([]);
	const [filtersParams, setFilterParams] = useState(null);
	const [newProjectSearch, setNewProjectSearch] = useState("");
	const [loading, setLoading] = useState(false);
	const [openSearch, setOpenSearch] = useState(false);
	const homeService = new HomeService();
	const compoundSearchService = new CompoundSearchService();
	const dispatch = useDispatch();
	const location = useLocation();
	const [pageOptions, setPageOptions] = useState({
		sizePerPage: 10,
		totalSize: 1,
	});

	const formatParamsHandler = (data) => {
		let value = "";
		for (let i = 0; i < data.length; i++) {
			if (i === 0) {
				value = data[i].value;
			} else {
				value = `${value},${data[i].value}`;
			}
		}
		return value;
	};

	useEffect(() => {
		dispatch(resetFilters());
	}, []);

	useEffect(() => {
		// debounce solution to reduce request data from api
		const timeoutId = setTimeout(() => {
			setLoading(true);
			if (filterData.compound?.trim()?.length || filterData?.delivery?.length) {
				document.getElementById("compoundNamme")?.blur();
				// document.getElementById("delivery").blur()
			}
			let params = {};
			if (filterData.compound?.trim().length)
				params["keyword"] = filterData.compound?.trim();
			params["budget"] = `${Math.round(filterData.budget[0])}-${Math.round(
				filterData.budget[1]
			)}`;
			params["area_sizs"] = `${Math.round(filterData.size[0])}-${Math.round(
				filterData.size[1]
			)}`;
			if (filterData.bedrooms.length)
				params["bedrooms"] = filterData.bedrooms.join();
			// if (location?.pathname?.includes('new-projects')) params["new_project"] = 1
			if (filterData.bathrooms.length)
				params["bathrooms"] = filterData.bathrooms.join();
			if (filterData.location) params["location"] = filterData.location.value;

			if (filterData.paymentMethods.length)
				params["payment_type"] = filterData.paymentMethods.join();
			if (filterData.categories_ids.length)
				params["categories_ids"] = formatParamsHandler(
					filterData.categories_ids
				);
			if (filterData.finishingType.length)
				params["finishing_type_ids"] = formatParamsHandler(
					filterData.finishingType
				);
			if (filterData.unitType.length)
				params["unit_type_ids"] = formatParamsHandler(filterData.unitType);
			if (filterData.delivery.length) params["delivery"] = filterData.delivery;

			setFilterParams({ ...params });
		}, 1000);

		return () => clearTimeout(timeoutId);
	}, [filterData]);
	return (
		<React.Fragment>
			<Navbar />
			<div className="websitPages">
				<MetaTags>
					<title>{t("Compounds Page")}</title>
				</MetaTags>
				<div>
					<Container fluid className="px-lg-5 pb-5 pt-4">
						<Row className="justify-content-around">
							{/* {(location?.pathname?.includes('new-projects') && openSearch) && } */}
							<Col lg={12} className="mb-3">
								<Row className="new-projects-search filter pt-6rem">
									<Col md={2} className="pb-3 pb-md-0">
										<div
											className="search-icon filter-modal-button"
											onClick={() => setOpenSearch(true)}>
											<svg
												width="22"
												height="20"
												viewBox="0 0 22 20"
												fill="none"
												xmlns="http://www.w3.org/2000/svg">
												<path
													d="M16 3C16 2.40666 16.1759 1.82664 16.5056 1.33329C16.8352 0.839943 17.3038 0.455426 17.8519 0.228363C18.4001 0.00129986 19.0033 -0.0581102 19.5853 0.0576455C20.1672 0.173401 20.7018 0.459124 21.1213 0.878681C21.5409 1.29824 21.8266 1.83279 21.9424 2.41473C22.0581 2.99667 21.9987 3.59987 21.7716 4.14805C21.5446 4.69623 21.1601 5.16477 20.6667 5.49441C20.1734 5.82406 19.5933 6 19 6C18.2044 6 17.4413 5.68393 16.8787 5.12132C16.3161 4.55871 16 3.79565 16 3ZM1 4H13C13.2652 4 13.5196 3.89464 13.7071 3.70711C13.8946 3.51957 14 3.26522 14 3C14 2.73479 13.8946 2.48043 13.7071 2.2929C13.5196 2.10536 13.2652 2 13 2H1C0.734784 2 0.48043 2.10536 0.292893 2.2929C0.105357 2.48043 0 2.73479 0 3C0 3.26522 0.105357 3.51957 0.292893 3.70711C0.48043 3.89464 0.734784 4 1 4ZM7 7C6.38106 7.00174 5.7778 7.19488 5.27293 7.55294C4.76807 7.911 4.38631 8.41645 4.18 9H1C0.734784 9 0.48043 9.10536 0.292893 9.2929C0.105357 9.48043 0 9.73479 0 10C0 10.2652 0.105357 10.5196 0.292893 10.7071C0.48043 10.8946 0.734784 11 1 11H4.18C4.36345 11.5189 4.6861 11.9773 5.11264 12.3251C5.53918 12.6729 6.05317 12.8966 6.59836 12.9718C7.14355 13.0471 7.69893 12.9709 8.20371 12.7516C8.70849 12.5323 9.14323 12.1784 9.46035 11.7286C9.77746 11.2788 9.96473 10.7504 10.0017 10.2013C10.0386 9.65219 9.92376 9.1035 9.66973 8.61528C9.41571 8.12706 9.03227 7.71812 8.5614 7.43323C8.09052 7.14833 7.55035 6.99846 7 7ZM21 9H13C12.7348 9 12.4804 9.10536 12.2929 9.2929C12.1054 9.48043 12 9.73479 12 10C12 10.2652 12.1054 10.5196 12.2929 10.7071C12.4804 10.8946 12.7348 11 13 11H21C21.2652 11 21.5196 10.8946 21.7071 10.7071C21.8946 10.5196 22 10.2652 22 10C22 9.73479 21.8946 9.48043 21.7071 9.2929C21.5196 9.10536 21.2652 9 21 9ZM9 16H1C0.734784 16 0.48043 16.1054 0.292893 16.2929C0.105357 16.4804 0 16.7348 0 17C0 17.2652 0.105357 17.5196 0.292893 17.7071C0.48043 17.8946 0.734784 18 1 18H9C9.26522 18 9.51957 17.8946 9.70711 17.7071C9.89464 17.5196 10 17.2652 10 17C10 16.7348 9.89464 16.4804 9.70711 16.2929C9.51957 16.1054 9.26522 16 9 16ZM21 16H17.82C17.5841 15.3328 17.1199 14.7704 16.5095 14.4124C15.8991 14.0543 15.1818 13.9235 14.4843 14.0432C13.7868 14.1629 13.154 14.5253 12.6979 15.0663C12.2418 15.6074 11.9916 16.2923 11.9916 17C11.9916 17.7077 12.2418 18.3926 12.6979 18.9337C13.154 19.4747 13.7868 19.8371 14.4843 19.9568C15.1818 20.0765 15.8991 19.9457 16.5095 19.5876C17.1199 19.2296 17.5841 18.6672 17.82 18H21C21.2652 18 21.5196 17.8946 21.7071 17.7071C21.8946 17.5196 22 17.2652 22 17C22 16.7348 21.8946 16.4804 21.7071 16.2929C21.5196 16.1054 21.2652 16 21 16Z"
													fill="var(--primary-color)"
												/>
											</svg>
											<span>{t("filter")}</span>
										</div>
									</Col>
									<Col md={8} className="pb-3 pb-md-0">
										<div className="search-input">
											{/* <svg
												width="24"
												height="24"
												viewBox="0 0 24 24"
												fill="none"
												xmlns="http://www.w3.org/2000/svg">
												<g clip-path="url(#clip0_345_1335)">
													<path
														d="M23.7075 22.293L17.7615 16.347C19.1735 14.622 20.0225 12.419 20.0225 10.022C20.0215 4.508 15.5355 0.0209961 10.0215 0.0209961C4.50748 0.0209961 0.0214844 4.508 0.0214844 10.021C0.0214844 15.534 4.50748 20.021 10.0215 20.021C12.4195 20.021 14.6225 19.172 16.3465 17.76L22.2925 23.706C22.4875 23.901 22.7435 23.999 22.9995 23.999C23.2555 23.999 23.5115 23.901 23.7065 23.706C24.0975 23.315 24.0975 22.683 23.7065 22.292L23.7075 22.293ZM13.5355 12.535L11.7145 14.316C11.2415 14.779 10.6215 15.009 10.0005 15.009C9.37949 15.009 8.75949 14.779 8.28549 14.316L6.47349 12.543C5.52149 11.592 5.00048 10.336 5.00048 9C5.00048 7.664 5.52149 6.408 6.46549 5.465C7.40849 4.521 8.66449 4 10.0005 4C11.3365 4 12.5915 4.521 13.5355 5.465C14.4795 6.409 15.0005 7.664 15.0005 9C15.0005 10.336 14.4795 11.592 13.5355 12.535ZM10.0005 6C9.19849 6 8.44549 6.312 7.88049 6.879C7.31349 7.445 7.00049 8.198 7.00049 9C7.00049 9.802 7.31249 10.555 7.87949 11.121L9.68449 12.887C9.85849 13.057 10.1425 13.057 10.3165 12.887L12.1295 11.114C12.6885 10.555 13.0005 9.802 13.0005 9.001C13.0005 8.2 12.6875 7.446 12.1215 6.88C11.5555 6.314 10.8015 6 10.0005 6ZM10.0005 9.993C9.44849 9.993 9.00049 9.545 9.00049 8.993C9.00049 8.441 9.44849 7.993 10.0005 7.993C10.5525 7.993 11.0005 8.441 11.0005 8.993C11.0005 9.545 10.5525 9.993 10.0005 9.993Z"
														fill="#A19D9E"
													/>
												</g>
												<defs>
													<clipPath id="clip0_345_1335">
														<rect width="24" height="24" fill="white" />
													</clipPath>
												</defs>
											</svg> */}

											<input
												type="text"
												placeholder="Search by area, Compound"
												value={newProjectSearch}
												id="compoundNamme"
												onChange={(e) => setNewProjectSearch(e.target?.value)}
											/>
										</div>
									</Col>
									<Col md={2} className="pb-3 pb-md-0">
										<button
											className="search-button"
											onClick={() =>
												dispatch(appendFilters({ compound: newProjectSearch }))
											}>
											{t("search")}
										</button>
									</Col>
								</Row>
							</Col>
							{/* : <Col lg={3}>
                                 <SideFilters loading={loading} setLoading={setLoading} updateFilterHandler={(data) => { }} type={"Compound"} />
                            </Col>} */}
							<Col lg={12}>
								{/* {location?.pathname?.includes('new-projects') ? <h2 style={{marginBottom: '40px'}}>{t("compounds")}</h2> : <Breadcrumb className='mb-0 ms-3 bredWebsite'>
                                    <BreadcrumbItem style={{ cursor: "pointer" }} onClick={() => {
                                        props.history.push("/")
                                    }}> {t("home")}
                                    </BreadcrumbItem>
                                    <BreadcrumbItem active> {t("compounds")}</BreadcrumbItem>
                                </Breadcrumb>} */}
								<Row>
									{!loading ? (
										compoundList.map((item, index) => {
											return (
												<Col lg={4} md={6} sm={6} key={index}>
													<CompoundCard
														compound={item}
														history={props.history}
														loaction={props.loaction}
													/>
												</Col>
											);
										})
									) : (
										<Skeleton.Compounds />
									)}
								</Row>
							</Col>
						</Row>
						<Row className="d-flex justify-content-end">
							<Col className="d-flex justify-content-end" md={12}>
								{location?.pathname?.includes("new-projects") ? (
									<PaginatorNewProjects
										service={compoundSearchService}
										pageOptions={pageOptions}
										setData={(data) => {
											if (data) {
												setCompoundList([...data]);
											}
											setLoading(false);
										}}
										setPageOptions={setPageOptions}
										filtersParams={filtersParams}
									/>
								) : (
									<Paginator
										service={homeService}
										pageOptions={pageOptions}
										setData={(data) => {
											setCompoundList([...data]);
											setLoading(false);
										}}
										setPageOptions={setPageOptions}
										filtersParams={filtersParams}
									/>
								)}
							</Col>
						</Row>
					</Container>
				</div>
			</div>
			<Footer />
			{location?.pathname?.includes("new-projects") && openSearch && (
				<Modal
					className="filter-modal"
					isOpen={openSearch}
					toggle={() => setOpenSearch(false)}>
					<div>
						<SideFilters
							loading={loading}
							setLoading={setLoading}
							updateFilterHandler={(data) => {}}
							type={"Compound"}
							setOpenSearch={setOpenSearch}
						/>
					</div>
				</Modal>
			)}
		</React.Fragment>
	);
};

export default CompoundsPage;
